import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-top-panel-4-icon',
  templateUrl: './layout-layout-top-panel-4.component.html'
})
export class LayoutLayoutTopPanel4Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
